module.exports = __webpack_public_path__ + "media/images/p5-a13dce70af9dfa03f4fde4acfadee43e.jpg";